module.exports = "/_next/static/images/5c99c0e779dd1323ecf02710c1d2174c-hero-lg.jpg";